import { __rest, __assign, __spreadArray } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { useMemo } from 'react';
import { ChartGradientColor } from './types.js';
import { useChartColor } from './ZigChart/util.js';

var deltaToShowSecondChart = 0.2;
var getGradient = function (gradientVariant, isGreen) {
    switch (gradientVariant) {
        case "mini":
            return isGreen ? ChartGradientColor.GreenMini : ChartGradientColor.RedMini;
        case "card":
            return isGreen ? ChartGradientColor.GreenCard : ChartGradientColor.RedCard;
        default:
            return isGreen ? ChartGradientColor.GreenFull : ChartGradientColor.RedFull;
    }
};
var getYDomain = function (data) {
    var values = data.map(function (s) { return s.y; });
    if (values.length === 0) {
        return [0, 0];
    }
    var ranges = [Math.min.apply(Math, __spreadArray([0], values, false)), Math.max.apply(Math, values)];
    if (ranges[0] < 0 && ranges[1] > 0) {
        ranges[0] = Math.min(ranges[0], (ranges[1] * -1 * deltaToShowSecondChart) / (1 - deltaToShowSecondChart));
    }
    else if (ranges[1] <= 0) {
        ranges[1] = Math.abs(ranges[1] - ranges[0]) * 0.01;
    }
    return ranges;
};
function useChartData(data, gradientVariant, precision) {
    var _a, _b;
    if (gradientVariant === void 0) { gradientVariant = "full"; }
    var chartColors = useChartColor();
    var _c = useMemo(function () {
        var chart = data.map(function (value, index) {
            var _a = typeof value === "object" ? value : { x: index, y: value }, x = _a.x, y = _a.y, rest = __rest(_a, ["x", "y"]);
            return __assign({ x: x, y: precision ? +y.toFixed(precision) : y }, rest);
        });
        var yDomain = getYDomain(chart);
        return [chart.map(function (c) { return (__assign(__assign({}, c), { y0: yDomain[0] })); }), yDomain];
    }, [data]), processedData = _c[0], yDomain = _c[1];
    var firstTimestamp = (_a = processedData[0]) === null || _a === void 0 ? void 0 : _a.y;
    var lastTimeStamp = (_b = processedData[data.length - 1]) === null || _b === void 0 ? void 0 : _b.y;
    var isGreen = firstTimestamp <= lastTimeStamp;
    return {
        data: processedData,
        color: isGreen ? chartColors.green : chartColors.red,
        gradient: getGradient(gradientVariant, isGreen),
        yDomain: yDomain,
    };
}

export { useChartData };
